'use es6';

import ActionTypes from '../actions/ActionTypes';
export const initialGettingStartedState = {
  isGetIsEnrolledRequesting: false,
  isGetIsEnrolledError: false,
  isEnrolledInGettingStarted: undefined,
  hasFetchedOnce: false
};
export function GettingStarted(state = initialGettingStartedState, action) {
  switch (action.type) {
    case ActionTypes.GETTING_STARTED_GET_REQUESTING:
      {
        return Object.assign({}, state, {
          isGetIsEnrolledRequesting: true,
          isGetIsEnrolledError: false,
          hasFetchedOnce: true
        });
      }
    case ActionTypes.GETTING_STARTED_GET_ERROR:
      {
        return Object.assign({}, state, {
          isGetIsEnrolledRequesting: false,
          isGetIsEnrolledError: true
        });
      }
    case ActionTypes.GETTING_STARTED_GET_RECEIVED:
      {
        return Object.assign({}, state, {
          isGetIsEnrolledRequesting: false,
          isGetIsEnrolledError: false,
          isEnrolledInGettingStarted: action.payload.isEnrolledInGettingStarted
        });
      }
    default:
      return state;
  }
}
export default GettingStarted;